
import React, { createContext, useContext, useState, ReactNode } from 'react';

export type EntityType = 'product' | 'subscription' | 'offer' | 'bundle' | 'transaction';

interface ModalState {
  isOpen: boolean;
  entityType?: EntityType;
  entityId?: string;
  entityData?: any; // Optional data to pass directly to modal
}

interface ModalContextType {
  modalState: ModalState;
  openModal: (entityType: EntityType, entityId: string, entityData?: any) => void;
  closeModal: () => void;
}

const initialState: ModalState = {
  isOpen: false
};

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export function useModal() {
  const context = useContext(ModalContext);
  if (context === undefined) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
}

export const ModalProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [modalState, setModalState] = useState<ModalState>(initialState);

  const openModal = (entityType: EntityType, entityId: string, entityData?: any) => {
    console.log(`Opening modal for ${entityType} with ID: ${entityId}`);
    setModalState({
      isOpen: true,
      entityType,
      entityId,
      entityData
    });
  };

  const closeModal = () => {
    setModalState({ ...modalState, isOpen: false });
  };

  return (
    <ModalContext.Provider value={{ modalState, openModal, closeModal }}>
      {children}
    </ModalContext.Provider>
  );
};

export default ModalContext;
